// Generic validation types
export default {
	CUSTOM_CALLBACK: 'CUSTOM_CALLBACK',
	CONTAINS: 'CONTAINS',
	EQUALS: 'EQUALS',
	IS_AFTER: 'IS_AFTER',
	IS_ALPHA: 'IS_ALPHA',
	IS_ALPHA_NUMERIC: 'IS_ALPHA_NUMERIC',
	IS_BEFORE: 'IS_BEFORE',
	IS_BOOLEAN: 'IS_BOOLEAN',
	IS_CURRENCY: 'IS_CURRENCY',
	IS_DECIMAL: 'IS_DECIMAL',
	IS_EMAIL: 'IS_EMAIL',
	IS_EMPTY: 'IS_EMPTY',
	IS_FLOAT: 'IS_FLOAT',
	IS_IN: 'IS_IN',
	IS_INT: 'IS_INT',
	IS_LENGTH: 'IS_LENGTH',
	IS_LOWERCASE: 'IS_LOWERCASE',
	IS_NOT_EMPTY: 'IS_NOT_EMPTY',
	IS_NUMERIC: 'IS_NUMERIC',
	IS_UPPERCASE: 'IS_UPPERCASE',
	MATCHES: 'MATCHES',
	MASK_COMPLETE: 'MASK_COMPLETE',
	REQUIRED: 'REQUIRED',
};
